import React from 'react';
import PropTypes from 'prop-types';

export function GelContentsBlock(props) {

  const getLanes = () => {

    let lanes = [];

    for(var lane in props.lanes){
      lanes.push({
        lane: lane.replace('lane', 'Lane '),
        contents: (props.lanes[lane].solutionAlias !== "")?props.lanes[lane].solutionAlias:"[Empty]"
      })
    }

    return (
      <>
        <h3 className={`${props.className}_title`}>Gel contains:</h3>
        <ul style={{listStyle: "none", padding: 0}}>
          {lanes.map(lane => (
            <li style={{
              marginBottom: "4px",
              color: (lane.lane.replace("Lane ", "lane") == props.selectedLane)?"#FAAC48":"white"
            }}><span style={{fontWeight: 'bolder'}}>{lane.lane}  </span>:{lane.contents}</li>
          ))}
        </ul>
      </>
    );
  }

  return (
    <div className={`${props.className}_block`}>
      <div className={props.className}>
        {getLanes()}
      </div>
    </div>
  );
}

GelContentsBlock.propTypes = {
  /**
   * ClassName to set on status warning component
   */
  className: PropTypes.string,
  /**
   * Boolean to set the Microcentrifuge Balanced Status Yes/No
   */
  lanes: PropTypes.array,
};

GelContentsBlock.defaultProps = {};
